import { makeStyles } from '@material-ui/core/styles';

export const useProductImageStyles = makeStyles(() => ({
  image: {
    width: (props) => (props.mobile ? 108 : 173),
    height: (props) => (props.mobile ? 108 : 173),
    objectFit: 'cover',
    filter: (props) =>
      props.purchaseState != 'normal' ? 'grayscale(100%)' : '',
    cursor: 'pointer',
  },
  skeleton: {
    width: (props) => (props.mobile ? 108 : 173),
    height: (props) => (props.mobile ? 108 : 173),
  },
}));

export const useButtonContainerStyles = makeStyles(() => ({
  button: {
    marginBottom: 5,
    lineHeight: '18px',
    height: 40,
  },
  fullWidth: {
    width: '100%',
  },
  link: {
    marginTop: 5,
    textDecoration: 'none',
  },
}));

export const useProductListStyles = makeStyles(() => ({
  container: {
    margin: '0px -16px 0px -16px',
    marginBottom: 24,
  },
  virtuoso: {
    height: window.innerHeight - 200,
  },
}));

export const useProductTicketInformationStyles = makeStyles(() => ({
  ticketIcon: {
    width: 20,
    height: 20,
    marginRight: 11,
  },
  container: {
    backgroundColor: '#5B73BA50',
    border: '1px solid #5B73BA',
    marginTop: '26px',
    borderRadius: '0px 0px 10px 10px',
    width: '100%',
  },
  footer: {
    backgroundColor: '#5B73BA90',
    margin: '0px -16px -16px -16px',
    paddingLeft: 16,
    marginTop: 9,
  },
}));

export const useProductMessageStyles = makeStyles(() => ({
  container: {
    borderRadius: 10,
  },
}));
